import React, { useState } from 'react';
import { 
  UserCheck, ShieldAlert, Users, AlertCircle, RefreshCw, QrCode, 
  X, FileText, UserPlus, Send, Lock, ShieldCheck, HeartPulse
} from 'lucide-react';

// ✅ CONEXIÓN AL SISTEMA NERVIOSO CENTRAL (Ruta Absoluta)
import { useGlobal } from 'context/GlobalContext';

const MiGrupo = () => {
  // --- CONSUMO DE DATOS GLOBALES ---
  const { ninos, registrarSalida, crearAlerta } = useGlobal();

  // --- ESTADOS LOCALES DE UI ---
  const [solicitandoApoyo, setSolicitandoApoyo] = useState(false);
  const [staffRequerido, setStaffRequerido] = useState([]);
  const [solicitandoRelevo, setSolicitandoRelevo] = useState(false);
  
  // Estados de Modales
  const [ninoParaEntrega, setNinoParaEntrega] = useState(null);
  const [codigoTicket, setCodigoTicket] = useState('');
  const [statusEntrega, setStatusEntrega] = useState('idle');
  const [modoContingencia, setModoContingencia] = useState(false);
  const [ninoParaReporte, setNinoParaReporte] = useState(null);
  const [textoReporte, setTextoReporte] = useState('');

  // CONFIGURACIÓN DEL GRUPO (En v3.1 vendrá del AuthContext)
  const staffCatalogo = ['Carlos Ruiz', 'Elena Ríos', 'Pedro Gómez', 'Sofía Lara', 'Juan Cano'];
  const grupoNombre = 'PÁRVULOS B';

  // FILTRAR NIÑOS: Solo los activos en este salón
  const misNinos = ninos.filter(n => n.salon === grupoNombre && n.estatus === 'en_salon');

  // --- LÓGICA DE NEGOCIO ---
  const manejarEnvioAlerta = () => {
    if(!textoReporte.trim()) return alert("Por favor, escribe el motivo del reporte.");
    
    crearAlerta(ninoParaReporte.nombre, ninoParaReporte.tipoAlerta, textoReporte);
    
    alert(`Reporte de ${ninoParaReporte.tipoAlerta} enviado para ${ninoParaReporte.nombre}. El Admin lo procesará.`);
    setNinoParaReporte(null);
    setTextoReporte('');
  };

  const validarEntregaFinal = () => {
    // Validación contra el ticket generado en recepción
    if (codigoTicket === ninoParaEntrega.ticket) {
      setStatusEntrega('success');
      setTimeout(() => {
        registrarSalida(ninoParaEntrega.id); 
        cerrarModalEntrega();
      }, 1200);
    } else {
      setStatusEntrega('error');
      setTimeout(() => setStatusEntrega('idle'), 2000);
    }
  };

  const entregaPorContingencia = (tutor) => {
    const confirm = window.confirm(`¿Confirmas la entrega manual de ${ninoParaEntrega.nombre} a ${tutor.nombre}? SE GENERARÁ UN REPORTE.`);
    if(confirm) {
      registrarSalida(ninoParaEntrega.id);
      crearAlerta(ninoParaEntrega.nombre, 'SEGURIDAD', `Salida manual autorizada por maestro para: ${tutor.nombre}`);
      cerrarModalEntrega();
    }
  };

  const cerrarModalEntrega = () => {
    setNinoParaEntrega(null);
    setModoContingencia(false);
    setCodigoTicket('');
    setStatusEntrega('idle');
  };

  return (
    <div className="w-full max-w-[1400px] mx-auto space-y-8 animate-in fade-in duration-500 pb-40 px-4 text-slate-900 text-left font-sans relative">
      
      {/* HEADER: PANEL DE CONTROL */}
      <div className="bg-white p-8 md:p-12 rounded-[4rem] shadow-xl border-b-[12px] border-indigo-600 flex flex-col xl:flex-row justify-between items-start gap-10">
        <div className="space-y-6 w-full max-w-2xl text-left">
          <div>
            <h2 className="text-5xl md:text-7xl font-black italic tracking-tighter leading-none uppercase">{grupoNombre}</h2>
            <p className="text-lg font-black text-indigo-500 uppercase tracking-[0.3em] mt-2 flex items-center gap-2 italic">
              <ShieldCheck size={24}/> Torre de Salón
            </p>
          </div>

          <div className="bg-slate-50 p-6 rounded-[2.5rem] border-2 border-slate-100 space-y-4 shadow-inner">
             <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest italic ml-2">Solicitar Soporte de Staff</span>
             <div className="flex flex-wrap gap-2">
                {staffRequerido.map(s => (
                  <span key={s} className="bg-indigo-600 text-white px-4 py-1.5 rounded-xl text-[10px] font-black flex items-center gap-2 uppercase shadow-sm">
                    {s} <X size={12} className="cursor-pointer" onClick={() => setStaffRequerido(staffRequerido.filter(x => x !== s))} />
                  </span>
                ))}
             </div>
             <div className="flex gap-2">
                <select 
                  onChange={(e) => {if(e.target.value && !staffRequerido.includes(e.target.value)) setStaffRequerido([...staffRequerido, e.target.value])}} 
                  className="flex-1 bg-white border-2 border-slate-200 p-4 rounded-2xl font-bold text-sm outline-none focus:border-indigo-500 appearance-none"
                >
                  <option value="">+ Seleccionar Instructor...</option>
                  {staffCatalogo.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
                <button onClick={() => {setSolicitandoApoyo(true); alert("Solicitud de apoyo en camino.");}} className="px-8 py-4 bg-[#0A2440] text-white rounded-2xl font-black uppercase text-[10px] tracking-widest flex items-center gap-2 hover:bg-indigo-600 transition-all shadow-lg active:scale-95">
                   {solicitandoApoyo ? <RefreshCw className="animate-spin" size={16}/> : <UserPlus size={16}/>} LLAMAR
                </button>
             </div>
          </div>
        </div>
        
        {/* INDICADOR DE PRESENTES */}
        <div className="bg-emerald-50 text-emerald-700 px-12 py-10 rounded-[3.5rem] border-4 border-emerald-200 flex items-center gap-8 shadow-inner min-w-[340px] xl:self-center">
          <Users size={64} strokeWidth={2.5} />
          <div className="flex flex-col text-center">
            <span className="text-8xl font-black leading-none tracking-tighter italic">
              {misNinos.length}
            </span>
            <span className="text-[10px] font-black uppercase tracking-[0.4em] opacity-60">Exploradores</span>
          </div>
        </div>
      </div>

      {/* GRID DE NIÑOS */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
        {misNinos.length === 0 ? (
          <div className="col-span-full py-32 bg-slate-100 rounded-[4rem] border-4 border-dashed border-slate-200 text-center flex flex-col items-center justify-center space-y-4 opacity-50">
             <Users size={80} strokeWidth={1} />
             <p className="font-black uppercase tracking-widest text-slate-400 italic">Esperando ingresos desde recepción...</p>
          </div>
        ) : (
          misNinos.map((nino) => (
            <div key={nino.id} className="p-8 bg-white rounded-[4rem] border-4 border-slate-50 shadow-2xl flex flex-col space-y-6 relative hover:border-indigo-100 transition-all duration-300">
              
              <div className="flex justify-between items-center">
                <div className="w-16 h-16 rounded-[1.8rem] bg-emerald-500 text-white flex items-center justify-center shadow-lg">
                  <UserCheck size={36} />
                </div>
                {nino.especial && (
                  <div className="bg-rose-100 text-rose-600 p-3 rounded-2xl animate-bounce border-2 border-rose-200 shadow-sm">
                    <AlertCircle size={24} />
                  </div>
                )}
              </div>

              <div className="text-center py-2">
                <h3 className="text-3xl font-black text-slate-900 leading-none italic tracking-tighter uppercase">{nino.nombre}</h3>
                <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-4 italic">Ticket: #{nino.ticket || '----'}</p>
              </div>

              <div className="space-y-3 pt-2">
                <div className="grid grid-cols-2 gap-3">
                  <button onClick={() => setNinoParaReporte({...nino, tipoAlerta: 'CONDUCTA'})} className="py-5 bg-rose-50 text-rose-700 border-2 border-rose-100 rounded-3xl flex flex-col items-center gap-1 hover:bg-rose-600 hover:text-white transition-all shadow-sm">
                    <ShieldAlert size={22} /> <span className="text-[9px] font-black uppercase tracking-widest">Reporte</span>
                  </button>
                  <button onClick={() => setNinoParaReporte({...nino, tipoAlerta: 'SALUD'})} className="py-5 bg-amber-50 text-amber-700 border-2 border-amber-100 rounded-3xl flex flex-col items-center gap-1 hover:bg-amber-600 hover:text-white transition-all shadow-sm">
                    <HeartPulse size={22} /> <span className="text-[9px] font-black uppercase tracking-widest">Salud</span>
                  </button>
                </div>
                <button onClick={() => setNinoParaEntrega(nino)} className="w-full py-6 bg-slate-900 text-white rounded-[2.5rem] font-black uppercase text-xs tracking-[0.2em] flex items-center justify-center gap-3 shadow-xl hover:bg-emerald-600 transition-all active:scale-95 border-b-8 border-slate-800">
                  <QrCode size={20} className="text-emerald-400" /> Confirmar Salida
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* BOTÓN SOS RELEVO FIJO */}
      <div className="fixed bottom-8 right-8 z-[60]">
        <button 
          onClick={() => {if(window.confirm("¿REQUIERES RELEVO URGENTE EN EL SALÓN?")) setSolicitandoRelevo(true)}}
          className={`w-28 h-28 rounded-full shadow-2xl flex flex-col items-center justify-center gap-1 transition-all active:scale-90 border-4 ${solicitandoRelevo ? 'bg-rose-600 text-white animate-pulse border-white' : 'bg-white text-rose-600 border-rose-600'}`}
        >
          <HeartPulse size={40} />
          <span className="text-[10px] font-black uppercase tracking-tighter">SOS Relevo</span>
        </button>
      </div>

      {/* MODALES DINÁMICOS */}
      {ninoParaReporte && (
        <div className="fixed inset-0 bg-slate-900/80 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
          <div className="bg-white w-full max-w-lg rounded-[3.5rem] p-10 space-y-6 border-4 border-slate-200 shadow-2xl animate-in zoom-in-95">
            <div className="flex items-center gap-3 text-rose-600">
               <ShieldAlert size={28} />
               <h3 className="text-2xl font-black uppercase italic tracking-tight">Reporte de {ninoParaReporte.tipoAlerta}</h3>
            </div>
            <textarea value={textoReporte} onChange={(e) => setTextoReporte(e.target.value)} className="w-full h-40 bg-slate-50 p-6 rounded-3xl border-2 border-slate-200 font-bold text-lg outline-none focus:border-indigo-500 shadow-inner" placeholder="Explica la situación para el Admin..." />
            <div className="grid grid-cols-2 gap-4">
               <button onClick={() => setNinoParaReporte(null)} className="py-5 bg-slate-100 text-slate-500 rounded-2xl font-black uppercase text-xs tracking-widest italic">Cerrar</button>
               <button onClick={manejarEnvioAlerta} className="py-5 bg-slate-900 text-white rounded-2xl font-black uppercase text-xs tracking-widest flex items-center justify-center gap-2 shadow-xl hover:bg-indigo-600 transition-all"><Send size={18}/> Enviar</button>
            </div>
          </div>
        </div>
      )}

      {ninoParaEntrega && (
        <div className="fixed inset-0 bg-slate-900/95 backdrop-blur-xl z-[100] flex items-center justify-center p-4 text-center">
          <div className="bg-white w-full max-w-xl rounded-[4.5rem] p-12 space-y-8 border-[6px] border-slate-100 shadow-2xl relative animate-in slide-in-from-bottom-8">
            {!modoContingencia ? (
              <>
                <div className="w-24 h-24 bg-slate-900 text-emerald-400 rounded-3xl mx-auto flex items-center justify-center shadow-2xl"><QrCode size={48} /></div>
                <h3 className="text-4xl font-black uppercase italic tracking-tighter">Validar Ticket</h3>
                <p className="font-bold text-slate-400 uppercase tracking-widest italic leading-none">{ninoParaEntrega.nombre}</p>
                <input 
                  type="text" maxLength="4" placeholder="••••" value={codigoTicket} 
                  onChange={(e) => setCodigoTicket(e.target.value.replace(/[^0-9]/g, ''))} 
                  className={`w-full p-8 bg-slate-50 rounded-[2.5rem] text-center text-7xl font-black tracking-[0.3em] border-4 outline-none transition-all shadow-inner ${statusEntrega === 'error' ? 'border-rose-500 text-rose-600' : 'border-slate-100 focus:border-indigo-500'}`} 
                />
                <div className="flex flex-col gap-4">
                  <button onClick={validarEntregaFinal} className="w-full py-7 bg-slate-900 text-white rounded-[2.5rem] font-black uppercase text-sm tracking-[0.3em] shadow-2xl hover:bg-emerald-600 transition-all active:scale-95">AUTORIZAR SALIDA</button>
                  <button onClick={() => setModoContingencia(true)} className="text-rose-600 font-black uppercase text-xs hover:scale-105 transition-transform tracking-widest italic">¿Olvidó el Ticket? Salida Manual</button>
                  <button onClick={cerrarModalEntrega} className="text-slate-400 font-black uppercase text-[10px] tracking-widest">Cancelar Proceso</button>
                </div>
              </>
            ) : (
              <div className="space-y-6 text-left animate-in fade-in">
                <div className="flex items-center gap-4 text-rose-600">
                  <ShieldAlert size={32}/>
                  <h3 className="text-2xl font-black uppercase italic leading-none">Protocolo Contingencia</h3>
                </div>
                <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest italic">Tutores autorizados para el retiro:</p>
                <div className="space-y-3 max-h-[350px] overflow-y-auto pr-2 hide-scrollbar">
                  {(ninoParaEntrega.tutores || []).map((t, i) => (
                    <div key={i} className="flex justify-between items-center p-6 bg-slate-50 rounded-3xl border-2 border-slate-100 shadow-inner">
                      <div>
                        <p className="font-black text-xl text-slate-900 uppercase italic tracking-tighter">{t.nombre}</p>
                        <p className="text-[9px] font-black text-indigo-500 uppercase mt-1 tracking-widest">ID Verificado</p>
                      </div>
                      <button onClick={() => entregaPorContingencia(t)} className="p-4 bg-rose-600 text-white rounded-2xl shadow-lg hover:bg-rose-700 active:scale-95 transition-all"><Lock size={24} /></button>
                    </div>
                  ))}
                </div>
                <button onClick={() => setModoContingencia(false)} className="w-full text-center text-slate-400 font-black uppercase text-xs tracking-widest pt-4">Volver a Escaneo de Código</button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MiGrupo;